<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #UnitsForm="ngForm" class="modal-form" novalidate>
    <div class="col-md-12 col-sm-12">
      <div class="form-group row">
        <div class="col-md-3 col-sm-12">
          <label for="UnitsCode">
            <small>{{ "code" | translate }} <i class="text-danger">*</i></small>
          </label>
        </div>
        <div class="col-md-9 col-sm-12">
          <input
            type="text"
            class="form-control form-control-sm"
            #UnitsCode="ngModel"
            #focusElement
            [disabled]="isReadOnly"
            name="UnitsCode"
            [ngClass]="alertShow && UnitsCode.invalid ? 'errorInput' : ''"
            [(ngModel)]="entity.code"
            id="UnitsCode"
            maxlength="10"
            required
          />
          <div *ngIf="alertShow && UnitsCode.invalid" class="errorMessage">
            {{ "important_area" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3 col-sm-12">
          <label for="UnitsName">
            <small
              >{{ "description" | translate }}
              <i class="text-danger">*</i></small
            >
          </label>
        </div>
        <div class="col-md-9 col-sm-12">
          <input
            type="text"
            class="form-control form-control-sm"
            name="UnitsName"
            [disabled]="isReadOnly"
            #UnitsName="ngModel"
            [ngClass]="alertShow && UnitsName.invalid ? 'errorInput' : ''"
            [(ngModel)]="entity.description"
            id="UnitsName"
            maxlength="50"
            required
          />
          <div *ngIf="alertShow && UnitsName.invalid" class="errorMessage">
            {{ "important_area" | translate }}
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-form-container>
<div class="modal-footer mt-4"></div>
